import React, { PropsWithChildren } from 'react';

import { Box, IconLink, Text } from '@betterment/samba-react';

import { WorkflowPage } from '../../../Shared/Components/WorkflowPage';

interface HeaderProps {
  onCancel: () => void;
  onBack?: () => void;
}

export const Header: React.FC<PropsWithChildren<HeaderProps>> = ({ children, onCancel, onBack }) => (
  <WorkflowPage.Header>
    <Box css={{ visibility: onBack ? 'visible' : 'hidden' }}>
      <IconLink
        label="Back"
        name="LeftArrow"
        spacing="compact"
        variant="ghostSecondary"
        role="button"
        onClick={onBack}
      />
    </Box>
    <Text
      css={{
        justifySelf: 'center',
      }}
      variant="text50"
    >
      {children}
    </Text>
    <Box
      css={{
        justifySelf: 'flex-end',
      }}
    >
      <IconLink label="Exit" name="X" spacing="compact" variant="ghostSecondary" role="button" onClick={onCancel} />
    </Box>
  </WorkflowPage.Header>
);
